module.exports = __webpack_public_path__ + "img/PY_document_icon@2x.117f2bb6.png";